export default __webpack_public_path__ + "7d7e5ce63374896f4e1b557a0beeeee4.svg";